//Get Reducer Call--->
export const getReturnOrderRequest = (page: number, size: number, search: string, order_id?: string, collection_day?: string) => ({
    type: 'GET_RETURN_ORDER_REQUEST',
    payload: { page, size, search, order_id, collection_day },
});

export const getReturnOrderSuccess = (data: any) => ({
    type: 'GET_RETURN_ORDER_SUCCESS',
    payload: { data },
});

export const getReturnOrderFailure = (data: string) => ({
    type: 'GET_RETURN_ORDER_FAILURE',
    payload: { data },
});


export const getAllReturnOrderRequest = () => ({
    type: 'GETALL_RETURN_ORDER_REQUEST',
});

export const getAllReturnOrderSuccess = (data: any) => ({
    type: 'GETALL_RETURN_ORDER_SUCCESS',
    payload: { data },
});

export const getAllReturnOrderFailure = (data: string) => ({
    type: 'GETALL_RETURN_ORDER_FAILURE',
    payload: { data },
});

export const resetGetAllReturnOrder = () => ({
    type: 'RESET_GETALL_RETURN_ORDER',
});

export const resetGetReturnOrder = () => ({
    type: 'RESET_GET_RETURN_ORDER',
});

//Create Reducer Call--->
export const createReturnOrderRequest = (data: any) => ({
    type: 'CREATE_RETURN_ORDER_REQUEST',
    payload: data,
});

export const createReturnOrderSuccess = (data: any) => ({
    type: 'CREATE_RETURN_ORDER_SUCCESS',
    payload: { data },
});

export const createReturnOrderFailure = (data: string) => ({
    type: 'CREATE_RETURN_ORDER_FAILURE',
    payload: { data },
});

export const resetCreateReturnOrder = () => ({
    type: 'RESET_CREATE_RETURN_ORDER',
});

//Update Reducer Call--->
export const updateReturnOrderRequest = (data: any, id: string) => ({
    type: 'UPDATE_RETURN_ORDER_REQUEST',
    payload: { data, id },
});

export const updateReturnOrderSuccess = (data: any) => ({
    type: 'UPDATE_RETURN_ORDER_SUCCESS',
    payload: { data },
});

export const updateReturnOrderFailure = (data: string) => ({
    type: 'UPDATE_RETURN_ORDER_FAILURE',
    payload: { data },
});

export const resetUpdateReturnOrder = () => ({
    type: 'RESET_UPDATE_RETURN_ORDER',
});
//Delete Reducer Call--->
export const deleteReturnOrderRequest = (id: string) => ({
    type: 'DELETE_RETURN_ORDER_REQUEST',
    payload: { id },
});

export const deleteReturnOrderSuccess = (data: any) => ({
    type: 'DELETE_RETURN_ORDER_SUCCESS',
    payload: { data },
});

export const deleteReturnOrderFailure = (data: string) => ({
    type: 'DELETE_RETURN_ORDER_FAILURE',
    payload: { data },
});

export const resetDeleteReturnOrder = () => ({
    type: 'RESET_DELETE_RETURN_ORDER',
});
